import React from "react";
import "./Popup.css";

import Quest from "../../images/imgQuest.png";
import Like from "../../images/like.svg";

function Popup(props) {


  return (
    <div className="popup" onClick={() => props.setPopupOpen(false)}>
       <div className="popup__popup" onClick={(e) => e.stopPropagation()}>
        <img alt="img" className="popup__popup__img" src={Quest}/>
             <div className="popup__popup__cont">
                <p className="popup__popup__cont__title">Найти артикул не сложно</p>
                <p className="popup__popup__cont__subtitle">Достаточно отыскать соответствующую надпись на задней или лицевой стороне. Это и будет артикул, который и нужно ввести в поиск.</p>
             </div>
             <div className="popup__popup__cont__btn">
                <button onClick={() => props.setPopupOpen(false)} type="button" className="popup__popup__cont__btn__btn"><img alt="img" src={Like}/>Теперь понятно</button>
             </div>
       </div>
    </div>
  );
}

export default Popup;